import { View } from 'foundations-components/components/View';
import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { makeLoadable } from '../components/common/LoadableWrapper';
import SideNav from '../components/layout/side-nav/SideNav';
import LoadingScreen from '../components/LoadingScreen';
import { ProductInfoContainer } from '../components/ProductInfoContainer';
import { getNavItemForProductLine } from '../utils/routingUtils';
import { useCurrencies } from './hooks/pricing/useCurrencyDetails';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// Loadable to avoid fetching mobile components until they are needed
const MobileCurrencyPicker = makeLoadable({
  loader: () => import( /* webpackChunkName: "mobile-currency-picker" */'./components/mobile/MobileCurrencyPicker'),
  LoadingComponent: LoadingScreen
});
const MobileDropdownNav = makeLoadable({
  loader: () => import( /* webpackChunkName: "mobile-dropdown-nav" */'./components/mobile/MobileDropdownNav'),
  LoadingComponent: LoadingScreen
});
export const ResponsivePageWrapper = ({
  productLine,
  navItem,
  children
}) => {
  const isMobile = useIsMobile();
  useCurrencies();
  const selectedNavItem = navItem !== null && navItem !== void 0 ? navItem : productLine ? getNavItemForProductLine(productLine) : null;
  if (isMobile) {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(MobileCurrencyPicker, {}), /*#__PURE__*/_jsx(MobileDropdownNav, {
        selectedNavItem: selectedNavItem !== null && selectedNavItem !== void 0 ? selectedNavItem : 'suite'
      }), /*#__PURE__*/_jsx(ProductInfoContainer, {
        children: /*#__PURE__*/_jsx(View, {
          maxInlineSize: "100%",
          children: children
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(PPUIGrid, {
    inlineSize: "100%",
    maxInlineSize: "1528px",
    margin: "auto",
    paddingBlockStart: "400",
    paddingInline: "200",
    gridTemplateAreas: `
        "side-nav content"
      `,
    gridTemplateColumns: "minmax(280px, auto) 1fr",
    rowGap: "400",
    children: [/*#__PURE__*/_jsx(PPUIGridItem, {
      gridArea: "side-nav",
      children: /*#__PURE__*/_jsx(SideNav, {
        selectedNavItem: selectedNavItem !== null && selectedNavItem !== void 0 ? selectedNavItem : 'suite'
      })
    }), /*#__PURE__*/_jsx(PPUIGridItem, {
      gridArea: "content",
      children: /*#__PURE__*/_jsx(ProductInfoContainer, {
        children: children
      })
    })]
  });
};